import InputForm  from '../../InputT';
import SearInputM  from '../../SearchModal';
import RadioBox from '../../Radiox';
import { useTranslation } from 'react-i18next';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import { Box, Grid } from '@mui/material';
import SearchInput from '../../SearchInput';

//emailCli 
//Initialisation des parametres de recherche 
let searchClient: ParamsPicklist = { CodeAgence: 'P', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: 'typcli', Choix: 22 }
//let searchTitre: ParamsPicklist = { CodeAgence: 'TITRES', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
 let searchTitre: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'TITRESCLIENT', Choix: 22 }

//let searchSituationFamiliale: ParamsPicklist = { CodeAgence: "SITFAM", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
 let searchSituationFamiliale: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "",colfiltre:'RUBRIQ',valfiltre:'SITFAM', Choix: 22 }
 
//let searchGestionnaire: ParamsPicklist = { CodeAgence: 'GESTIONNAIRE', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
  let searchGestionnaire: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'GESTIONNAIRE',Choix: 22 }

// let searchProspect: ParamsPicklist = { CodeAgence: '', Table: "DEMARC", Colonne1: "CODDMR", Colonne2: "LIBELL", Colagence: '001', Choix: 22 }
// let searchClassRisque: ParamsPicklist = { CodeAgence: '', Table: "CLARIS", Colonne1: "CLARIS", Colonne2: "LIBELLFR", Colagence: '001', Choix: 22 }
// let searchPays: ParamsPicklist = { CodeAgence: '', Table: "CDPAYS", Colonne1: "CDPAYS", Colonne2: "LIBELL", Colagence: '001', Choix: 22 }
// let searchActivite: ParamsPicklist = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '001', Choix: 22 }
// let searchUniteInstitutionnel: ParamsPicklist = { CodeAgence: '', Table: "TABNUI", Colonne1: "CODNUI", Colonne2: "LIBELL", Colagence: '001', Choix: 22 }
// let searchRegimeMatrimonial: ParamsPicklist = { CodeAgence: "REGMAT", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
 let searchProspect: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'DEMARCHEUR', Choix: 22 }
  let searchClassRisque: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'CLASSERISQUE', Choix: 22 }
  let searchPays: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'PAYS', Choix: 22 }
  let searchActivite: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'ACTIVITE', Choix: 22 }
  let searchUniteInstitutionnel: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'UNITEINSTITUTIONNELLE', Choix: 22 }
  let searchRegimeMatrimonial: ParamsPicklist = { CodeAgence: "", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "",colfiltre:'RUBRIQ',valfiltre:'REGMAT', Choix: 22 }

//
// let searchNiveauInstruction: ParamsPicklist = { CodeAgence: '', Table: "INSTRU", Colonne1: "CODINS", Colonne2: "LIBELL", Colagence: '001', Choix: 22 }
// let searchEthnie: ParamsPicklist = { CodeAgence: '', Table: "ETHNIE", Colonne1: "CODETH", Colonne2: "LIBELL", Colagence: '001', Choix: 22 }
// let searchCateGo: ParamsPicklist = { CodeAgence: '', Table: "CATEGO", Colonne1: "CATEGO", Colonne2: "LIBELLFR", Colagence: '001', Choix: 22 }
// let searchZoneGeo: ParamsPicklist = { CodeAgence: '', Table: "RESIDE", Colonne1: "CDRESI", Colonne2: "LIBELLFR", Colagence: '001', Choix: 22 }

let searchNiveauInstruction: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'NIVEAUETUDE', Choix: 22 }
  let searchEthnie: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'ETHNIE', Choix: 22 }
  let searchCateGo: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'PROFESSION', Choix: 22 }
  let searchZoneGeo: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'ZONEGEOGRAPHYQUE', Choix: 22 }
  let searchTypePiece: ParamsPicklist = { CodeAgence: "", Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: '',colfiltre:'RUBRIQ',valfiltre:'TYPPIECE', Choix: 22 };

const Tab1 = (props: { etatG?: boolean, form: any, Function?: Function }) => {
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();


  //information du client
  let informationclient = {
    SearchClient: {
      Titre: t("FormClientPhysique.informationclient.SearchClient.Titre"),
      label: t("FormClientPhysique.informationclient.SearchClient.label"),
      name: "NUMCLI", params: searchClient
    },
    SearchTitre: {
      Titre: t("FormClientPhysique.informationclient.SearchTitre.Titre"),
      label: t("FormClientPhysique.informationclient.SearchTitre.label"),
      name: "TITCLI", params: searchTitre
    },
    RadioSexe: {
      label: t("FormClientPhysique.informationclient.RadioSexe.label"),
      LibValue1: t("FormClientPhysique.informationclient.RadioSexe.LibValue1"),
      LibValue2: t("FormClientPhysique.informationclient.RadioSexe.LibValue2"),
      name: "CLSEXE"
    },
    RadioDirigeantE: {
      label: t("FormClientPhysique.informationclient.RadioDirigeantE.label"),
      LibValue1: t("FormClientPhysique.informationclient.RadioDirigeantE.LibValue1"),
      LibValue2: t("FormClientPhysique.informationclient.RadioDirigeantE.LibValue2"),
      name: "autreInfo"
      //suspend
    },
    InputDateNaissance: {
      label: t("FormClientPhysique.informationclient.InputDateNaissance.label"),
      name: "DATNAI"
    },
    SearchSITFAM: {
      Titre: t("FormClientPhysique.informationclient.SearchSITFAM.Titre"),
      label: t("FormClientPhysique.informationclient.SearchSITFAM.label"),
      name: "SITFAM", params: searchSituationFamiliale
    },
    SearchSIGestionnaire: {
      Titre: t("FormClientPhysique.informationclient.SearchGestionnaire.Titre"),
      label: t("FormClientPhysique.informationclient.SearchGestionnaire.label"),
      name: "CDGEST", params: searchGestionnaire
    },
    SearchProspect: {
      Titre: t("FormClientPhysique.informationclient.SearchProspect.Titre"),
      label: t("FormClientPhysique.informationclient.SearchProspect.label"),
      name: "codProspect", params: searchProspect
    },
    SearchClasseRisque: {
      Titre: t("FormClientPhysique.informationclient.SearchClasseRisque.Titre"),
      label: t("FormClientPhysique.informationclient.SearchClasseRisque.label"),
      name: "CLARIS", params: searchClassRisque
    },
    SearchNationalite: {
      Titre: t("FormClientPhysique.informationclient.SearchNationalite.Titre"),
      label: t("FormClientPhysique.informationclient.SearchNationalite.label"),
      name: "CDPAYS", params: searchPays
      //suspend
    },
    SearchActivite: {
      Titre: t("FormClientPhysique.informationclient.SearchActivite.Titre"),
      label: t("FormClientPhysique.informationclient.SearchActivite.label"),
      name: "CDENAE", params: searchActivite
    },
    SearchUniteI: {
      Titre: t("FormClientPhysique.informationclient.SearchUniteI.Titre"),
      label: t("FormClientPhysique.informationclient.SearchUniteI.label"),
      name: "CDENUI", params: searchUniteInstitutionnel
    },
    SearchPaysR: {
      Titre: t("FormClientPhysique.informationclient.SearchPaysR.Titre"),
      label: t("FormClientPhysique.informationclient.SearchPaysR.label"),
      name: "CDERES", params: searchPays
    },
    InputCleCli: {
      label: t("FormClientPhysique.informationclient.InputCleCli.label"),
      name: "CLECLI"
    },
    InputNom: {
      label: t("FormClientPhysique.informationclient.InputNom.label"),
      name: "NOMCLI"
    },
    InputPrenom: {
      label: t("FormClientPhysique.informationclient.InputPrenom.label"),
      name: "PRECLI"
    },
    RadioActionnaire: {
      label: t("FormClientPhysique.informationclient.RadioActionnaire.label"),
      LibValue1: t("FormClientPhysique.informationclient.RadioActionnaire.LibValue1"),
      LibValue2: t("FormClientPhysique.informationclient.RadioActionnaire.LibValue2"),
      name: "actionaire"
    },
    InputLieuNaissance: {
      label: t("FormClientPhysique.informationclient.InputLieuNaissance.label"),
      name: "LIENAI"
    },
    InputPieceIdentite: {
      label: t("FormClientPhysique.informationclient.InputPieceIdentite.label"),
      name: "numCNI"
    },
    InputExpiredate: {
      label: t("FormClientPhysique.informationclient.InputExpiredate.label"),
      name: "DateDelcni"
    },
    InputNIU: {
      label: t("FormClientPhysique.informationclient.InputNIU.label"),
      name: "NIU"
      //suspend
    },
    SearchRegimeMatrimonial: {
      Titre: t("FormClientPhysique.informationclient.SearchRegimeMatrimonial.Titre"),
      label: t("FormClientPhysique.informationclient.SearchRegimeMatrimonial.label"),
      name: "REGMAT", params: searchRegimeMatrimonial
    },
    SearchNiveauInstruction: {
      Titre: t("FormClientPhysique.informationclient.SearchNiveauInstruction.Titre"),
      label: t("FormClientPhysique.informationclient.SearchNiveauInstruction.label"),
      name: "CDENUI", params: searchNiveauInstruction
    },
    SearchEthnie: {
      Titre: t("FormClientPhysique.informationclient.SearchEthnie.Titre"),
      label: t("FormClientPhysique.informationclient.SearchEthnie.label"),
      name: "ETHNIE", params: searchEthnie
    },
    SearchCatego: {
      Titre: t("FormClientPhysique.informationclient.SearchCatego.Titre"),
      label: t("FormClientPhysique.informationclient.SearchCatego.label"),
      name: "CATCLI", params: searchCateGo
    },
    SearchZoneGeo: {
      Titre: t("FormClientPhysique.informationclient.SearchZoneGeo.Titre"),
      label: t("FormClientPhysique.informationclient.SearchZoneGeo.label"),
      name: "RESIDE", params: searchZoneGeo
      //suspend   
    },
  }

  return (
    <div className='tabItem' >
      <Grid container className='border' sx={{ width: "85%", position: "absolute" }}>
        <Grid item xs={12} md={6} className='border-left'>
          <SearchInput notRequired dissabledCode={true} form={props.form} width={9} Titre={informationclient.SearchClient.Titre} label={informationclient.SearchClient.label} name={informationclient.SearchClient.name} Parametre={informationclient.SearchClient.params} />
          <SearInputM  disabled={true} notRequired form={props.form} width={9} Taille2={150} Titre={informationclient.SearchTitre.Titre} label={informationclient.SearchTitre.label} name={informationclient.SearchTitre.name} Parametre={informationclient.SearchTitre.params} />
          <RadioBox  disabled={true} width={9} label={informationclient.RadioSexe.label} name={informationclient.RadioSexe.name} Value1='M' Value2='F' LibValue1={informationclient.RadioSexe.LibValue1} libVlue2={informationclient.RadioSexe.LibValue2} />
          <RadioBox etat={false} disabled={true} width={9} label={informationclient.RadioDirigeantE.label} name={informationclient.RadioDirigeantE.name} Value1='O' Value2='N' LibValue1={informationclient.RadioDirigeantE.LibValue1} libVlue2={informationclient.RadioDirigeantE.LibValue2} />
          <InputForm  disabled={true}  notRequired width={9} label={informationclient.InputDateNaissance.label} name={informationclient.InputDateNaissance.name} type='date' error='obligation' />
          <SearInputM  disabled={true} notRequired form={props.form} width={9} Taille2={150} Titre={informationclient.SearchSITFAM.Titre} label={informationclient.SearchSITFAM.label} name={informationclient.SearchSITFAM.name} Parametre={informationclient.SearchSITFAM.params} />
          <SearInputM  disabled={true} notRequired form={props.form} width={9} Taille2={150} Titre={informationclient.SearchSIGestionnaire.Titre} label={informationclient.SearchSIGestionnaire.label} name={informationclient.SearchSIGestionnaire.name} Parametre={informationclient.SearchSIGestionnaire.params} />
          <SearInputM  disabled={true} notRequired form={props.form} width={9} Taille2={150} Titre={informationclient.SearchProspect.Titre} label={informationclient.SearchProspect.label} name={informationclient.SearchProspect.name} Parametre={searchProspect} />
          <SearInputM  disabled={true} notRequired form={props.form} width={9} Taille2={150} Titre={informationclient.SearchClasseRisque.Titre} label={informationclient.SearchClasseRisque.label} name={informationclient.SearchClasseRisque.name} Parametre={informationclient.SearchClasseRisque.params} />
          <SearInputM  disabled={true} notRequired form={props.form} width={9} Taille2={150} Titre={informationclient.SearchNationalite.Titre} label={informationclient.SearchNationalite.label} name={informationclient.SearchNationalite.name} Parametre={informationclient.SearchNationalite.params} />
          <SearInputM  disabled={true} notRequired form={props.form} width={9} Taille2={150} Titre={informationclient.SearchActivite.Titre} label={informationclient.SearchActivite.label} name={informationclient.SearchActivite.name} Parametre={informationclient.SearchActivite.params} />
          <SearInputM  disabled={true} notRequired form={props.form}  width={9} Taille2={150} Titre='Recherche Catégorié Socio Profetionnel' label='Catégorié Socio Prof' name='CATPRO' Parametre={searchCateGo} />
        </Grid>

        <Grid item xs={12} md={6} className='border-left'>
          <InputForm  disabled={true} notRequired width={10} label={informationclient.InputNom.label} name={informationclient.InputNom.name} type='text' error='ce Champ est obligatoire' />
          <InputForm  disabled={true} notRequired width={10} label={informationclient.InputPrenom.label} name={informationclient.InputPrenom.name} type='text' error='ce Champ est obligatoire' />
          <RadioBox  disabled={true}  width={10} label={informationclient.RadioActionnaire.label} name={informationclient.RadioActionnaire.name} Value1='O' Value2='N' LibValue1={informationclient.RadioActionnaire.LibValue1} libVlue2={informationclient.RadioActionnaire.LibValue2} />
          <InputForm  disabled={true} notRequired width={10} label={informationclient.InputLieuNaissance.label} name={informationclient.InputLieuNaissance.name} type='text' error='ce Champ est obligatoire' />
          <InputForm  disabled={true} notRequired width={10} label={informationclient.InputPieceIdentite.label} name={informationclient.InputPieceIdentite.name} type='text' error='ce Champ est obligatoire' />
          <InputForm  disabled={true} notRequired width={10} label={informationclient.InputExpiredate.label} name={informationclient.InputExpiredate.name} type='date' error='ce Champ est obligatoire' />
          <InputForm  disabled={true} notRequired width={10} label={informationclient.InputNIU.label} name={informationclient.InputNIU.name} type='text' error='ce Champ est obligatoire' />
          <SearInputM  disabled={true}  form={props.form} width={10} Taille2={150} Titre={informationclient.SearchRegimeMatrimonial.Titre} label={informationclient.SearchRegimeMatrimonial.label} name={informationclient.SearchRegimeMatrimonial.name} Parametre={informationclient.SearchRegimeMatrimonial.params} />
          <SearInputM  disabled={true} notRequired form={props.form}  width={10} Taille2={150} Titre='Recherche Niveau instruction' label='Niveau instruction' name='INSTRU' Parametre={searchNiveauInstruction} />
          <SearInputM  disabled={true} notRequired form={props.form} width={10} Taille2={150} Titre='Recherche Ethnie' label='Code Ethnie' name='ETHNIE' Parametre={searchEthnie} />
          <SearInputM  disabled={true} notRequired form={props.form} width={10} Taille2={150} Titre={informationclient.SearchUniteI.Titre} label={informationclient.SearchUniteI.label} name={informationclient.SearchUniteI.name} Parametre={informationclient.SearchUniteI.params} />
          <SearInputM  disabled={true} notRequired form={props.form} width={10} Taille2={150} Titre={informationclient.SearchPaysR.Titre} label={informationclient.SearchPaysR.label} name={informationclient.SearchPaysR.name} Parametre={searchPays} />
          <SearInputM  disabled={true} notRequired form={props.form}  width={9} Taille2={150} Titre='Recherche Zone Géographique' label='Zone Géographique' name='RESIDE' Parametre={searchZoneGeo} />
        </Grid>

      </Grid>
    </div>

  );
}

export default Tab1;